import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ColDef, GridApi, GridReadyEvent } from "ag-grid-community";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { AgGridActionbutton } from "src/app/shared/common/AgGridActionbutton";
import { GenericBadgeRendererComponent } from "src/app/shared/common/generic-badge-renderer.component";
import { JsignalService } from "src/app/shared/services/jsignal.service";
import { CreateSignalPopupComponent } from "../../jsignal-product/review-activities/create-signal-popup/create-signal-popup.component";
import { CreateSignalSourcesPopUpComponent } from "./create-signal-sources-pop-up/create-signal-sources-pop-up.component";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";
import { constants } from "src/app/shared/common/contants";

@Component({
    selector: "app-signal-config",
    templateUrl: "./signal-config.component.html",
    styleUrls: ["./signal-config.component.scss"],
    standalone: false
})
export class SignalConfigComponent implements OnInit {
  defaultColDef: ColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      }
  };
  columnDefs: ColDef[];

  gridApi: GridApi | null = null;

  pageSize = 10;
  currentPage = 1;
  totalPages = 1;
  totalRows = 0;
  startRow = 1;
  endRow = 10;
  rowData: any;
  components: any = {
    buttonRenderer: AgGridActionbutton,
  };
  activeComponent: "Source_mapping" | "validation_activity_config" =
    "Source_mapping"; // default
  isEditMode = false;
  initialSlaValue: any;
  generalForm!: FormGroup;
  validationSlaId: number | null = null;

  constructor(
    private dialog: MatDialog,
    private jsignalsService: JsignalService,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private fb: FormBuilder,
    private localStorage: LocalStorageSettingsService,
    private constants: constants,
  ) {}

  ngOnInit(): void {
    this.buildGeneralConfigForm();
    this.intializeSourceMappingGrid();
    this.loadAllSignalSources();
    this.loadSlaConfig();
  }

  buildGeneralConfigForm() {
    this.generalForm = this.fb.group({
      slaDays: [
        { value: 30, disabled: true },
        [Validators.required, Validators.min(1), Validators.pattern('^[0-9]+$')],
      ],
    });
  }

  intializeSourceMappingGrid() {
    this.columnDefs = [
      {
        headerName: "Source Type",
        width: 200,
        field: "value",
        sortable: true,
        ...this.jsignalsService.autoTooltip("Source Type"),
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Source Name",
        width: 200,
        field: "name",
        sortable: true,
         ...this.jsignalsService.autoTooltip("Source Name"),
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Status",
        field: "status",
        width: 200,
         ...this.jsignalsService.autoTooltip("Status"),
        cellRenderer: GenericBadgeRendererComponent,
        cellRendererParams: { type: "YES_NO" },
      },
      {
        headerName: "Created By",
        field: "createdBy",
        width: 200,
        sortable: true,
         ...this.jsignalsService.autoTooltip("Created By"),
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Created Date",
        field: "createdDate",
        width: 200,
        sortable: true,
         ...this.jsignalsService.autoTooltip("Created Date"),
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Last Modified By",
        field: "lastModifiedBy",
        width: 200,
        sortable: true,
         ...this.jsignalsService.autoTooltip("Last Modified By"),
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Last Modified Date",
        field: "lastModifiedDate",
        width: 200,
        sortable: true,
         ...this.jsignalsService.autoTooltip("Last Modified Date"),
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Action",
        filter: false,
        width: 120,
        cellRenderer: "buttonRenderer",
        pinned: "right",
        lockPinned: true,
        cellRendererParams: {
          edit: this.EditIcon.bind(this),
          delete: this.deleteIcon.bind(this),
        },
      },
    ];
  }

  EditIcon(data) {
    console.log(data.rowData);

    if (data.rowData.status === "No") {
      this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
      return;
    }

    let dialogRef = this.dialog.open(CreateSignalSourcesPopUpComponent, {
      width: "80%",
      autoFocus: false,
      maxWidth: "100vw",
      height: "80%",
      disableClose: true,
      data: {
        mode: "edit", // or 'create'
        rowData: data.rowData, // existing data
      },
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      // this.onGridReady(this.gridApi);
      this.loadAllSignalSources();
    });
  }
  deleteIcon(event) {
    if (event.rowData.status === "No") {
      this.snackBar.open(this.constants.deleterowMsg, "OK", { duration: 5000 });
      return;
    }

    const confirmed = window.confirm(
      "Are you sure you want to delete the selected record ?"
    );
    if (!confirmed) {
      return;
    }

    this.spinner.start();
    this.jsignalsService
      .delteSignalSourceConfiguration(event.rowData.id)
      .subscribe({
        next: (response) => {
          if (response.error === true) {
            this.snackBar.open(response.statusMessage, "Close", {
              duration: 3000,
            });
            this.spinner.stop();
            return;
          }
          this.snackBar.open(response.statusMessage, "Close", {
            duration: 3000,
          });
          this.loadAllSignalSources();
          this.spinner.stop();
        },
        error: (error) => {
          console.error("Error :", error);
          this.snackBar.open(error.statusMessage, "Close", {
            duration: 3000,
          });
          this.loadAllSignalSources();
          this.spinner.stop();
        },
      });
    
  }

  onGridReady(params: GridReadyEvent): void {
    this.gridApi = params.api;
    this.loadAllSignalSources();

    // Auto-size columns on load
    setTimeout(() => {
      if (this.gridApi) {
        this.gridApi.sizeColumnsToFit();
      }
    }, 100);
  }

  loadAllSignalSources() {
    this.spinner.start();
    this.jsignalsService.getAllSignalSources().subscribe({
      next: (response) => {
        if (response.error === true) {
          this.snackBar.open(response.statusMessage, "Close", {
            duration: 3000,
          });
          this.spinner.stop();
          return;
        }

        this.rowData = response;
        this.gridApi?.setGridOption('rowData', this.rowData);
        this.spinner.stop();
      },
      error: (error) => {
        console.error("Error fetching signal sources:", error);
        this.snackBar.open("Failed to load signal sources", "Close", {
          duration: 3000,
        });
        this.spinner.stop();
      },
    });
  }

  onCreate() {
    let dialogRef = this.dialog.open(CreateSignalSourcesPopUpComponent, {
      width: "80%",
      autoFocus: false,
      maxWidth: "100vw",
      height: "80%",
      disableClose: true,
      data: {},
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      // this.onGridReady(this.gridApi);
      this.loadAllSignalSources();
    });
  }

  onRefresh() {
    this.loadAllSignalSources();
  }

  onGeneralConfigRefresh() {
    this.loadSlaConfig();
  }

  onDownload() {
    this.spinner.start();

    setTimeout(() => {
      this.gridApi.exportDataAsCsv({
        fileName: "Signal_Configuration.csv",
      });

      this.spinner.stop();
    }, 500);
  }

  goToFirst() {
    this.gridApi.paginationGoToFirstPage();
    this.onPageChange();
  }

  goToPrevious() {
    this.gridApi.paginationGoToPreviousPage();
    this.onPageChange();
  }

  goToNext() {
    this.gridApi.paginationGoToNextPage();
    this.onPageChange();
  }

  goToLast() {
    this.gridApi.paginationGoToLastPage();
    this.onPageChange();
  }

  // 🚀 Call API / analytics / logging here
  onPageChange() {
    console.log("Page changed:", this.currentPage);
    // call backend / emit event / analytics
  }

  showSourceMapping() {
    this.activeComponent = "Source_mapping";
    this.intializeSourceMappingGrid();
    this.loadAllSignalSources();
  }

  showGeneralConfig() {
    this.activeComponent = "validation_activity_config";
    // this.buildGeneralConfigForm();
    //load existing config from backend and patch the form
    this.loadSlaConfig();
  }

  enableEdit() {
    this.isEditMode = true;
    this.generalForm.enable();
  }

  cancelEdit() {
    this.isEditMode = false;

    this.generalForm.patchValue({
      slaDays: this.initialSlaValue,
    });

    this.generalForm.disable();
  }

  saveGeneralConfig() {
    if (this.generalForm.invalid) {
      this.generalForm.markAllAsTouched();
      return;
    }

    if (!this.validationSlaId) {
      console.error("Validation SLA ID is missing.");
      this.snackBar.open(
        "Validation SLA ID is missing. Please try again.",
        "Close",
        {
          duration: 3000,
        },
      );
      return;
    }

    const DnsName = this.localStorage.getSettings("dnsName");
    const Workspaceid = this.localStorage.getSettings("WorkspaceId");

    const payload = {
      configType: "VALIDATION_SLA",
      value: this.generalForm.value.slaDays.toString(),
      dnsId: DnsName,
      workspaceId: Workspaceid,
    };

    console.log(payload);

    this.spinner.start();
    this.jsignalsService
      .updateSignalConfigurationbasedOnType(this.validationSlaId, payload)
      .subscribe({
        next: (response) => {
          if (response.error === true) {
            this.snackBar.open(response.statusMessage, "Close", {
              duration: 3000,
            });
            this.spinner.stop();
            return;
          }
          this.snackBar.open(response.statusMessage, "Close", {
            duration: 3000,
          });
          this.spinner.stop();
        },
        error: (error) => {
          console.error("Error fetching signal sources:", error);
          this.snackBar.open("Failed to load signal sources", "Close", {
            duration: 3000,
          });
          this.spinner.stop();
        },
      });

    this.generalForm.disable();
    this.isEditMode = false;
  }

  loadSlaConfig() {
    // Call API to get SLA config. using the validationSlaId
    this.spinner.start();
    this.jsignalsService.getValidationSla().subscribe({
      next: (response) => {
        if (response.error === true) {
          this.snackBar.open(response.statusMessage, "Close", {
            duration: 3000,
          });
          this.spinner.stop();
          return;
        }

            try {
              const data = response?.find((x: any) => x.configType === "VALIDATION_SLA");

              if (!data) {
                console.warn("VALIDATION_SLA not found in response");
                this.spinner.stop();
                return;
              }

              this.validationSlaId = data?.id;
              console.log("Validation SLA ID:", this.validationSlaId);

              this.initialSlaValue = Number(data?.value ?? 0);
              console.log("API VALUE:", data?.value, typeof data?.value);

              this.generalForm.patchValue({
                slaDays: this.initialSlaValue,
              });

            } catch (error) {
              console.error("Error while processing VALIDATION_SLA:", error);
              this.spinner.stop();
            }

        this.spinner.stop();
      },
      error: (error) => {
        console.error("Error fetching signal sources:", error);
        this.snackBar.open("Failed to load signal sources", "Close", {
          duration: 3000,
        });
        this.spinner.stop();
      },
    });
  }

  allowOnlyNumbers(event: KeyboardEvent): void {
  const allowedKeys = [
    'Backspace',
    'Tab',
    'ArrowLeft',
    'ArrowRight',
    'Delete'
  ];

  if (
    allowedKeys.includes(event.key) ||
    /^[0-9]$/.test(event.key)
  ) {
    return;
  }

  event.preventDefault();
}
}
